import { Controller } from 'stimulus';
import jump from 'jump.js';
import inViewport from '../helpers/inViewport';

class IframeBlockController extends Controller {
  onToggleOverlay() {
    this.overlayTarget.classList.add('is-hidden');
    this.backButtonTarget.classList.remove('is-hidden');

    if (this.data.get('fullscreen')) {
      jump(this.element, {
        callback: () => {
          document.body.classList.add('overflow-hidden');
          this.element.classList.add('is-fullscreen');
        },
      });

      return;
    }

    if (!inViewport(this.backButtonTarget)) {
      jump(this.element);
    }
  }

  onBack() {
    this.overlayTarget.classList.remove('is-hidden');
    this.backButtonTarget.classList.add('is-hidden');

    if (this.data.get('fullscreen')) {
      document.body.classList.remove('overflow-hidden');
      this.element.classList.remove('is-fullscreen');
    }
  }
}

IframeBlockController.targets = [
  'overlay',
  'backButton',
];

export default IframeBlockController;
